import { PendingButton } from '../components/common/PendingButton';
import { G } from './glyphs';
import { useSheetFocus } from './useSheetFocus';

// LEAVING A REQUEST HALF-MADE (Freddi, 2026-10-08). The close control asks
// before it throws anything away — and only when there is something to throw
// away: an untouched step 1 leaves at once (`isUntouched`).
//
// A MODAL, NOT A DRAWER (Freddi, 2026-10-08). A drawer is somewhere to do
// more; this is one question that stops the page until it is answered, so it
// sits in the middle, on the scrim, and says it in the customer app's own
// centred-card voice — the message page's title, lead and stacked actions. It
// borrows nothing from the desk's modals, which belong to the desk (R-IN-1).
//
// Staying is the primary and comes first: the safe answer is the one a thumb
// lands on. Leaving is quiet, worded as what it does — "Discard request", not
// "Yes" — so the button reads right without the question above it. The lead
// says the two things a customer wonders: is my work kept (no) and did
// anything go to Patricia (no). Escape, the scrim and Keep going all stay.

export function LeaveDialog({ onStay, onLeave, mayHaveSent = false, what = 'request' }: { onStay: () => void; onLeave: () => void; mayHaveSent?: boolean; /** The request wizard's, the pay sheet's screenshot (deposit-proof AC1b), or the dogs drawer's card (vaccination-cards). */ what?: 'request' | 'screenshot' | 'card' }) {
  const box = useSheetFocus(onStay);
  return (
    <div className="cp-backdrop center" onClick={onStay}>
      <div
        className="cp-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="cp-leave-t"
        aria-describedby="cp-leave-d"
        tabIndex={-1}
        ref={box}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="cp-leave-t" className="mp-title">{what === 'request' ? 'Leave this request?' : 'Leave without sending?'}</h2>
        {/* After a send that did not answer, "nothing has been sent" may be
            false (PR #242 review): the request is kept, and Home asks again
            with the same id as soon as it loads. */}
        <p id="cp-leave-d" className="mp-lead">
          {mayHaveSent
            ? 'Your request may already have reached Patricia — we’ll check for you.'
            : what === 'screenshot'
              ? 'Your screenshot won’t be sent. Nothing has gone to Patricia.'
              : what === 'card'
                ? 'Your card won’t be sent. Nothing has gone to Patricia.'
              : 'Your answers and dates won’t be kept. Nothing has been sent to Patricia.'}
        </p>
        <div className="mp-actions">
          <PendingButton className="mp-btn primary" icon={G.arrowRight({ size: 15 })} onClick={onStay}>
            Keep going
          </PendingButton>
          {/* Leaving reloads Home: busy until it does. */}
          {mayHaveSent ? (
            <PendingButton className="mp-btn quiet" leaves onClick={onLeave}>
              Leave for now
            </PendingButton>
          ) : (
            <PendingButton className="mp-btn quiet cp-discard" icon={G.cross({ size: 15 })} leaves onClick={onLeave}>
              {what === 'screenshot' ? 'Discard the screenshot' : what === 'card' ? 'Discard the card' : 'Discard request'}
            </PendingButton>
          )}
        </div>
      </div>
    </div>
  );
}
